document.addEventListener("DOMContentLoaded", function () {
const qtyInput = document.getElementById("qty");
const btnMinus = document.getElementById("qty-minus");
const btnPlus = document.getElementById("qty-plus");
const variantInput = document.getElementById("custom-variant-id");
const priceEl = document.getElementById("custom-price");
const rows = document.querySelectorAll("#price-table tbody tr");

const variants = Array.from(rows).map(row => {
    const rango = row.dataset.rango.trim();
    let min = 0, max = Infinity;

    if (rango.includes("-")) {
    const parts = rango.split("-");
    min = parseInt(parts[0], 10);
    max = parseInt(parts[1], 10);
    } else if (rango.includes("+")) {
    min = parseInt(rango.replace("+", ""), 10);
    max = Infinity;
    }

    return {
    id: row.dataset.variantId,
    title: rango,
    min,
    max,
    price: parseFloat(row.querySelector("td:last-child").textContent.replace(/[^0-9]/g, "")) // fallback
    };
});

function updateVariant(qty) {
    let variant = variants.find(v => qty >= v.min && qty <= v.max);
    if (!variant) variant = variants[0]; // fallback

    variantInput.value = variant.id;

    // Resaltar fila activa
    rows.forEach(r => r.classList.remove("active"));
    const activeRow = document.querySelector(`#price-table tr[data-variant-id="${variant.id}"]`);
    if (activeRow) activeRow.classList.add("active");

    // Mostrar precio formateado en COP
    priceEl.textContent = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP"
    }).format(variant.price );
}

btnMinus.addEventListener("click", () => {
    let qty = parseInt(qtyInput.value, 10) || 1;
    if (qty > 1) qty--;
    qtyInput.value = qty;
    updateVariant(qty);
});

btnPlus.addEventListener("click", () => {
    let qty = parseInt(qtyInput.value, 10) || 1;
    qty++;
    qtyInput.value = qty;
    updateVariant(qty);
});

qtyInput.addEventListener("input", () => {
    const qty = parseInt(qtyInput.value, 10) || 1;
    updateVariant(qty);
});

// Inicializar
updateVariant(parseInt(qtyInput.value, 10));
});